import { CardDTO } from "./GameTypes";

export type LiteratureSetId =
  | "low_clubs"
  | "low_diamonds"
  | "low_hearts"
  | "low_spades"
  | "high_clubs"
  | "high_diamonds"
  | "high_hearts"
  | "high_spades"
  | "jokers";

export const LITERATURE_SET_LABELS: Record<LiteratureSetId, string> = {
  low_clubs: "Low Clubs (2–7)",
  low_diamonds: "Low Diamonds (2–7)",
  low_hearts: "Low Hearts (2–7)",
  low_spades: "Low Spades (2–7)",
  high_clubs: "High Clubs (9–A)",
  high_diamonds: "High Diamonds (9–A)",
  high_hearts: "High Hearts (9–A)",
  high_spades: "High Spades (9–A)",
  jokers: "Eights & Jokers",
};

export function literatureCardKey(suit: string, rank: string): string {
  return `${suit}\u0000${rank}`;
}

/** Mirrors server `cardsInSet` for declare UI. */
export function cardsInLiteratureSet(setId: LiteratureSetId): CardDTO[] {
  const suits = ["Clubs", "Diamonds", "Hearts", "Spades"] as const;
  const low = ["2", "3", "4", "5", "6", "7"];
  const high = ["9", "10", "J", "Q", "K", "A"];
  const out: CardDTO[] = [];
  if (setId === "jokers") {
    for (const s of suits) out.push({ suit: s, rank: "8" });
    out.push({ suit: "Joker", rank: "Red" });
    out.push({ suit: "Joker", rank: "Black" });
    return out;
  }
  const map: Record<string, { suit: string; ranks: string[] }> = {
    low_clubs: { suit: "Clubs", ranks: low },
    low_diamonds: { suit: "Diamonds", ranks: low },
    low_hearts: { suit: "Hearts", ranks: low },
    low_spades: { suit: "Spades", ranks: low },
    high_clubs: { suit: "Clubs", ranks: high },
    high_diamonds: { suit: "Diamonds", ranks: high },
    high_hearts: { suit: "Hearts", ranks: high },
    high_spades: { suit: "Spades", ranks: high },
  };
  const spec = map[setId];
  if (!spec) return [];
  for (const rank of spec.ranks) out.push({ suit: spec.suit, rank });
  return out;
}

export function cardToLiteratureSetId(card: CardDTO): LiteratureSetId | null {
  const s = card.suit;
  const r = card.rank;
  if (r === "8" || s === "Joker") return "jokers";
  if (["2", "3", "4", "5", "6", "7"].includes(r)) {
    const m: Record<string, LiteratureSetId> = {
      Clubs: "low_clubs",
      Diamonds: "low_diamonds",
      Hearts: "low_hearts",
      Spades: "low_spades",
    };
    return m[s] ?? null;
  }
  if (["9", "10", "J", "Q", "K", "A"].includes(r)) {
    const m: Record<string, LiteratureSetId> = {
      Clubs: "high_clubs",
      Diamonds: "high_diamonds",
      Hearts: "high_hearts",
      Spades: "high_spades",
    };
    return m[s] ?? null;
  }
  return null;
}

export function sameLiteratureHalfSuit(a: CardDTO, b: CardDTO): boolean {
  const sa = cardToLiteratureSetId(a);
  const sb = cardToLiteratureSetId(b);
  return sa !== null && sa === sb;
}

export function allLiteratureSetIds(): LiteratureSetId[] {
  return [
    "low_clubs",
    "low_diamonds",
    "low_hearts",
    "low_spades",
    "high_clubs",
    "high_diamonds",
    "high_hearts",
    "high_spades",
    "jokers",
  ];
}
